// UW Ops maintenance reference values shared by Dry Docks and Hull Events.
export const hullEventTypes = ["Hull Cleaning", "Hull Inspection", "Propeller Polishing"] as const;
export const propellerCoatingTypes = [
  "No Coating",
  "Silicone/Paint coating",
  "GIT Coating",
  "Ultrasonic Protection",
] as const;

export type HullEventType = (typeof hullEventTypes)[number];

export interface VesselDryDock {
  imoNumber: string;
  dryDockDate: string;
  antifoulingApplicationDate: string | null;
  nextPlannedDryDockDate: string | null;
  place: string | null;
  comments: string | null;
  paintVendor: string | null;
  flatBottomPaint: string | null;
  verticalSidePaint: string | null;
  bootTopPaint: string | null;
  paintSchemePurpose: string | null;
  propellerCoatingType: string | null;
}

export type CreateVesselDryDockInput = Omit<VesselDryDock, "imoNumber">;
export type UpdateVesselDryDockInput = Partial<Omit<CreateVesselDryDockInput, "dryDockDate">>;

export interface VesselHullEvent {
  eventId: string;
  requestId: string | null;
  imoNumber: string;
  eventDate: string;
  eventType: HullEventType;
  place: string | null;
  vendor: string | null;
  comments: string | null;
}

export type CreateVesselHullEventInput = Omit<VesselHullEvent, "eventId" | "requestId" | "imoNumber">;
export type UpdateVesselHullEventInput = Partial<Pick<VesselHullEvent, "place" | "vendor" | "comments">>;

export interface PaintOption {
  vendor: string;
  paint: string;
}
